import Component from './person';
export default Component;
